"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Counter = void 0;
var tslib_1 = require("tslib");
var React = (0, tslib_1.__importStar)(require("react"));
var padding_1 = require("../../padding");
var text_1 = require("../../text");
function Counter(props) {
    var length = props.length, maxLength = props.maxLength;
    return (React.createElement(padding_1.Padding, { y: 8 },
        React.createElement(text_1.Text, { textAlign: "right", size: "small" },
            length,
            " / ",
            maxLength)));
}
exports.Counter = Counter;
//# sourceMappingURL=counter.js.map